import ForgotPasswordAckPaper from './ForgotPasswordAckPaper';

export default ForgotPasswordAckPaper;
